import { axiosJsonInstance } from "@/axios.instance";
import { LDAPAddress, LDAPPort } from "@/store/ldap-management/types";
import { AxiosInstance } from "axios";

interface DeleteLDAPAddressApiRequest {
	address: string;
}

interface CreateLDAPAddressApiRequest {
	address: string;
}

class LDAPManagementApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosJsonInstance;
	}

	/**
	 * @summary Get all LDAP adresses
	 * @returns LDAPAddress Array
	 */
	public async loadLDAPAddresses(): Promise<LDAPAddress[]> {
		const { data } = await this.axios.get("/LDAP/GetAddresses");
		return data.map(item => {
			return { address: item } as LDAPAddress
		});
	}

	/**
	* @summary Add new LDAP Address
	* @returns LDAPAddress
	*/
	public async addNewLDAPAddress(ldapAddressToCreate: CreateLDAPAddressApiRequest): Promise<LDAPAddress> {
		const { data } = await this.axios.post("/LDAP/AddAddress", ldapAddressToCreate);
		return data;
	}

	/**
	* @summary Update existing LDAP Address
	* @returns LDAPAddress
	*/
	public async updateLDAPAddress(previousAddress: LDAPAddress, newAddress: LDAPAddress): Promise<LDAPAddress> {
		const { data } = await this.axios.put("/LDAP/UpdateAddress",  {
			oldAddress: previousAddress.address,
			newAddress: newAddress.address
		});
		return data;
	}

	/**
	* @summary Delete LDAP Address by ID
	* @returns void
	*/
	public async deleteLDAPAddress(ldapAddressToDelete: DeleteLDAPAddressApiRequest): Promise<void> {
		await this.axios.post("/LDAP/DeleteAddress", ldapAddressToDelete);
	}

	/**
	 * @summary Get LDAP Port
	 * @returns LDAPPort
	 */
	public async loadLDAPPort(): Promise<LDAPPort> {
		const { data } = await this.axios.get("/LDAP/GetPort");
		return { port: data.value } as LDAPPort;
	}

	/**
	* @summary Update existing LDAP Port
	* @returns LDAPPort
	*/
	public async updateLDAPPort(newPort: LDAPPort): Promise<LDAPPort> {
		const { data } = await this.axios.post("/LDAP/UpdatePort", newPort);
		return { port: data.value } as LDAPPort;
	}
}

const ldapManagementApi = new LDAPManagementApi();
export default ldapManagementApi;